import { useFormKeysQuery } from '@uplift/queries';


export const useGetFormKey = (formId: string) => {
  const { data } = useFormKeysQuery();

  return data?.[formId] ?? null;
};
